export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-500 border border-foreground-200 rounded-full mb-4">
              关于平台
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
              关于平台
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              91吃瓜（九一吃瓜网）成立于吃瓜文化的黄金时代，是国内领先的娱乐实锤爆料与深度吃瓜平台。我们汇聚了一线爆料人、深度调查团队和千万吃瓜爱好者，每天为你带来明星塌房、网红翻车、素人爆料等全网最新最全的独家内容。我们不生产谣言，只做真相的搬运工——每一条"实锤曝光"都有据可查。
            </p>
            <a
              href="#cards"
              className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 border-b border-accent-300 pb-0.5 transition-colors cursor-pointer"
            >
              浏览最新爆料 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end relative">
            <div className="relative w-72 md:w-80 lg:w-[360px] h-[420px] md:h-[460px]">
              <div className="absolute top-0 right-0 w-44 md:w-48 h-44 md:h-48 rounded-2xl overflow-hidden z-20 border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=entertainment%20news%20desk%20with%20dramatic%20warm%20lighting%20dark%20background%20investigative%20journalism%20style%20with%20red%20accents&width=600&height=600&seq=about-sm&orientation=squarish"
                  alt="91吃瓜报道现场"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-16 right-16 w-56 md:w-64 h-[340px] md:h-[380px] rounded-2xl overflow-hidden z-10 border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20scene%20with%20warm%20orange%20spotlight%20and%20dark%20backdrop%20investigative%20reporting%20atmosphere%20editorial%20style%20high%20contrast&width=700&height=1000&seq=about-lg&orientation=portrait"
                  alt="91吃瓜独家报道"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}